import axios from "../../api/axios";
import { isValidPostalCode } from "./validatePostalCode";

// récupération des informations de code postal
export const fetchPostalCodeDetails = async (postalCode: string): Promise<{ 
    city: string; 
    cities?: string[]; 
    registrationOffice?: string; 
} | null> => {

    // Vérification de la validité du code postal
    if ( !isValidPostalCode(postalCode) ) {
        return null;
    }

    try {
        // appel API
        const response = await axios(`/rne/code-postal/${postalCode}`);
        
        if ( response.status !== 200 ) {
            return null;
        }

        const data = response.data;
        console.log( 'data', data );

        return {
            city: data.data.villes?.[0],
            cities: data.data.villes,
            registrationOffice: data.data.greffe
    };
    } catch (error) {
        console.error(error);
        return null;
    }
};